import { render, staticRenderFns } from "./adminCreate.vue?vue&type=template&id=ca523d26&"
import script from "./adminCreate.vue?vue&type=script&lang=js&"
export * from "./adminCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports